import React from "react";
import "./Privacy_Policy.css";
import { Container } from "react-bootstrap";

const Privacy_Policy = () => {
  return (
    <>
      <section className="  terms-section">
        <div className=" card_div">
          <img
            src="/assets/images/banner/privacy-policy-banner.png"
            alt="Privacy Policy Banner"
            className="policy-banner terms-banner"
          />
          <div className="card-text container">
            <div className="description_div">
              <p className="grey_class_paragraph">
                At Oll type services , your privacy is important to us. This
                Privacy Policy outlines how we collect, use, and protect your
                personal information when you use our website or purchase our
                fresh products. When you place an order, we collect basic
                personal details such as your name, email address, phone number,
                and delivery address. We may also collect technical data such as
                your IP address and browser information to help us improve your
                browsing experience and enhance our website performance..
              </p>
            </div>
            <h2 className="head_div">1. INFORMATION WE COLLECT</h2>
            <div className="description_div">
              <p className="grey_class">
                When you place an order or browse our website, we collect
                information such as your name, phone number, delivery address,
                email, and payment details. We may also gather technical data
                like your IP address, device type, and browsing behavior through
                cookies and analytics tools. This information helps us
                personalize your experience and ensure smooth order processing.
              </p>
            </div>
            <h2 className="head_div">2. HOW WE USE YOUR INFORMATION</h2>
            <div className="description_div">
              <p className="grey_class">
                We use your personal details to fulfill your orders, send order
                updates, and respond to your inquiries. If you opt in, we may
                also send occasional promotional messages or seasonal offers.
                Your data helps us improve our services, manage customer
                support, and analyze user behavior to enhance our website and
                delivery processes.
              </p>
            </div>
            <h2 className="head_div">3. SHARING OF INFORMATION</h2>
            <div className="description_div">
              <p className="grey_class">
                We only share your data with trusted third parties when
                necessary—such as delivery personnel to complete your order, or
                payment gateways to securely process your transactions. These
                partners are bound by confidentiality and data protection
                agreements. We do not sell, rent, or trade your information with
                outside parties for marketing purposes.
              </p>
            </div>
            <h2 className="head_div">4. PAYMENT AND SECURITY</h2>
            <div className="description_div">
              <p className="grey_class">
                All payments are processed securely through reputable payment
                gateways. We do not store or have access to your credit or debit
                card numbers. Our website uses SSL encryption and other security
                practices to safeguard your information from unauthorized
                access, misuse, or loss.
              </p>
            </div>
            <h2 className="head_div">5. COOKIES AND TRACKING TECHNOLOGIES</h2>
            <div className="description_div">
              <p className="grey_class">
                We use cookies to enhance your browsing experience by
                remembering your preferences, login sessions, and cart items.
                These cookies also help us understand how you interact with our
                website so we can improve functionality and design. You can
                modify or disable cookies anytime via your browser settings.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy_Policy;
